import React from 'react';
import Button from '@/components/CustomButtons/Button';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingButton = ({
  isLoading,
  children,
  variant = 'contained',
  color = 'primary',
  ...props
}) => {
  return (
    <Button
      {...props}
      variant={variant}
      color={color}
      disabled={isLoading || props.disabled}>
      {isLoading ? (
        <CircularProgress
          size={20}
          style={{ marginRight: '10px', color: 'white' }}
        />
      ) : (
        children
      )}
    </Button>
  );
};

export default LoadingButton;
